import { onBeforeUnmount, onMounted, reactive, ref } from 'vue'

export const useContextMenu = () => {
  const contextMenuVisible = ref(false)
  const contextMenuItem = ref(null)
  const contextMenuPosition = reactive({ x: 0, y: 0 })

  const closeContextMenu = () => {
    contextMenuVisible.value = false
    contextMenuItem.value = null
  }

  const handleContextMenu = (event, item) => {
    const requiredClasses = ['ai-menu-v2__item', 'active', 'ai-menu-v2__item--mayi']
    if (!requiredClasses.every((className) => event.currentTarget.classList.contains(className))) {
      return
    }

    event.preventDefault()
    const menuWidth = 144
    const menuHeight = 46
    contextMenuPosition.x = Math.min(event.clientX, window.innerWidth - menuWidth - 8)
    contextMenuPosition.y = Math.min(event.clientY, window.innerHeight - menuHeight - 8)
    contextMenuItem.value = item
    contextMenuVisible.value = true
  }

  const handleContextMenuKeydown = (event) => {
    if (event.key === 'Escape') closeContextMenu()
  }

  onMounted(() => {
    document.addEventListener('click', closeContextMenu)
    document.addEventListener('scroll', closeContextMenu, true)
    window.addEventListener('resize', closeContextMenu)
    window.addEventListener('keydown', handleContextMenuKeydown)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('click', closeContextMenu)
    document.removeEventListener('scroll', closeContextMenu, true)
    window.removeEventListener('resize', closeContextMenu)
    window.removeEventListener('keydown', handleContextMenuKeydown)
  })

  return {
    contextMenuVisible,
    contextMenuItem,
    contextMenuPosition,
    closeContextMenu,
    handleContextMenu
  }
}
